import React, {useContext, useMemo} from "react";
import classnames from "classnames";
import {Col} from "reactstrap";
import LazyImage from "../../../../../../../../components/app-specific/lazy-image";
import {UserHomepageControllerContext} from "../../../../../../index";
import {UserHomepageEventEmitter, UserHomepageViewMode} from "../../../../../../models";
import {Fade, Tooltip} from "@mui/material";

const UserPhoneHomepageCategories = ({component, tabId, viewMode}) => {
    const controller = useContext(UserHomepageControllerContext);
    const categories = useMemo(() => component?.content?.categories ?? [], [component])

    /** @type{boolean} */
    const showMoreButton = useMemo(() => true, [])
    /** @type{boolean}*/
    const moreButtonInvisible = useMemo(() => false, [])

    /**
     * Invokes the appropriate controller callback for the click of the categories more button.
     */
    const onMoreButtonClicked = () => {
        if (viewMode === UserHomepageViewMode.preview)
            return;
        controller.selectComponentSearchButton(tabId, component.id, UserHomepageEventEmitter.view);
    }

    /**
     * Invokes the appropriate controller callback for the click of a category.
     * @param category
     */
    const onCategoryClicked = (category) => {
        controller.clickContent(tabId, component.id, category.id, UserHomepageEventEmitter.view);
    }

    /**@type {JSX.Element}*/
    const moreButton = useMemo(() => (
        <button
            onClick={onMoreButtonClicked}
            className={classnames('user-phone-homepage-more-button', {'not-visible': moreButtonInvisible})}>
            More
        </button>
    ), [moreButtonInvisible, viewMode])


    return (
        <>
            <div className={'user-phone-homepage-categories'}>
                <div className={'component-title'}>
                    <p>
                        {component?.title ?? ''}
                    </p>
                    <div>
                        <Fade in={showMoreButton}>
                            {
                                moreButtonInvisible
                                    ? <Tooltip title={'No search query or search type specified'}>
                                        {moreButton}
                                    </Tooltip>
                                    : viewMode === UserHomepageViewMode.preview
                                        ? <Tooltip title={"Users will see the list of categories by clicking on the" +
                                            " more button"}>
                                            {moreButton}
                                        </Tooltip>
                                        : moreButton
                            }
                        </Fade>
                    </div>
                </div>
                <div className={'d-flex flex-wrap w-100 justify-content-center'}>
                    {
                        categories.map((category) => (
                            <Col key={category?.id} xs={6}
                                 className={classnames('user-phone-homepage-category-card')}>
                                <div
                                    key={category.id}
                                    id={category.phoneViewElementId}
                                    onClick={() => onCategoryClicked(category)}>
                                    <div className={'image'}>
                                        <LazyImage
                                            src={category?.coverFileName}
                                            alt={category?.coverFileName ?? ''}
                                        />
                                    </div>
                                    <div className={'w-100'}>
                                        <p className={'title'}>
                                            {category?.title ?? ''}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        ))
                    }
                </div>
            </div>
        </>
    );
}


export default UserPhoneHomepageCategories;
